"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
/**
 * 注册制审核-创业板详情
 */
var web_1 = __importDefault(require("../../config/web"));
var fieldtools_1 = __importDefault(require("../../src/modules/commonutil/fieldtools"));
var table_jbxx = $("#table_jbxx");
var table_jgxx = $("#table_jgxx");
var table_cwzb = $("#table_cwzb");
var table_zygd = $("#table_zygd");
loadcontent();
function loadcontent() {
    //infocode
    fieldtools_1["default"].isEmpty(info.INFO_CODE) ? undefined : $("#pdfurl").attr('href', "https://pdf.dfcfw.com/pdf/H2_" + info.INFO_CODE + "_1.pdf").show();
    //基本信息
    getdata({
        reportName: "RPT_ORGANIZATION_DECLARE_INFO",
        columns: "DECLARE_ORG,PREDICT_LISTING_MARKET,STATE,UPDATE_DATE,RECOMMEND_ORG,SPONSOR,ACCOUNT_FIRM,SIGN_ACCOUNTANT,LAW_FIRM,SIGN_LAWYER,IS_SUBMIT,ORG_CODE,DECLARE_ORG"
    }).then(function (json) {
        if (json && json.result && json.result.data && json.result.data.length > 0) {
            var data = json.result.data[0];
            $(".DECLARE_ORG", table_jbxx).html(data.DECLARE_ORG); //发行人全称	DECLARE_ORG
            $(".PREDICT_LISTING_MARKET", table_jbxx).html(data.PREDICT_LISTING_MARKET); //拟上市地点	PREDICT_LISTING_MARKET
            $(".STATE", table_jbxx).html(data.STATE); //证监会审核状态	STATE
            $(".UPDATE_DATE", table_jbxx).html(fieldtools_1["default"].dateformat(data.UPDATE_DATE)); //更新日期	UPDATE_DATE
            $(".RECOMMEND_ORG", table_jbxx).html(data.RECOMMEND_ORG); //保荐机构	RECOMMEND_ORG
            $(".SPONSOR", table_jbxx).html(data.SPONSOR); //保荐代表人	SPONSOR
            $(".ACCOUNT_FIRM", table_jbxx).html(data.ACCOUNT_FIRM); //会计师事务所	ACCOUNT_FIRM
            $(".SIGN_ACCOUNTANT", table_jbxx).html(data.SIGN_ACCOUNTANT); //签字会计师	SIGN_ACCOUNTANT
            $(".LAW_FIRM", table_jbxx).html(data.LAW_FIRM); //律师事务所	LAW_FIRM
            $(".SIGN_LAWYER", table_jbxx).html(data.SIGN_LAWYER); //签字律师	SIGN_LAWYER
            $(".IS_SUBMIT", table_jbxx).html(data.IS_SUBMIT); //是否已参加抽查抽签或现场检查	IS_SUBMIT
            $("#content_jbxx").show();
            $(".gstype").html('已申报企业');
        }
    });
    //机构信息
    getdata({
        reportName: "RPT_HSF9_BASIC_ORGINFO",
        columns: "REG_ADDRESS,FOUND_DATE,LEGAL_PERSON,CHAIRMAN,ORG_PROFILE,BUSINESS_SCOPE"
    }).then(function (json) {
        if (json && json.result && json.result.data.length > 0) {
            var data = json.result.data[0];
            $(".REG_ADDRESS", table_jgxx).html(data.REG_ADDRESS); //注册地	REG_ADDRESS
            $(".FOUND_DATE", table_jgxx).html(fieldtools_1["default"].dateformat(data.FOUND_DATE)); //成立日期	FOUND_DATE
            $(".LEGAL_PERSON", table_jgxx).html(data.LEGAL_PERSON); // 法人代表	LEGAL_PERSON
            $(".CHAIRMAN", table_jgxx).html(data.CHAIRMAN); // 董事长	CHAIRMAN
            $(".ORG_PROFILE", table_jgxx).html(data.ORG_PROFILE); //公司简介	ORG_PROFILE
            $(".BUSINESS_SCOPE", table_jgxx).html(data.BUSINESS_SCOPE); //经营范围	BUSINESS_SCOPE
            // $(".REG_ADDRESS", table_jgxx).html('<span class="red">暂无数据来源</span>')//注册地	REG_ADDRESS
            // $(".FOUND_DATE", table_jgxx).html('<span class="red">暂无数据来源</span>')//成立日期	FOUND_DATE
            // $(".LEGAL_PERSON", table_jgxx).html('<span class="red">暂无数据来源</span>')// 法人代表	LEGAL_PERSON
            // $(".CHAIRMAN", table_jgxx).html('<span class="red">暂无数据来源</span>')// 董事长	CHAIRMAN
            // $(".ORG_PROFILE", table_jgxx).html('<span class="red">暂无数据来源</span>')//公司简介	ORG_PROFILE
        }
    });
    //财务数据
    getdata({
        reportName: "RPT_FNINDICATOR_DECLARE",
        columns: "REPORT_DATE,TOTAL_ASSETS_ADJUST,TOTAL_EQUITY_ADJUST,TOTAL_EQUITY_ADJUST,MINORITY_EQUITY_ADJUST,TOTAL_OPERATE_INCOME,PARENT_NETPROFIT,CAPITAL_RESERVE_ADJUST,UNASSIGN_RPOFIT_ADJUST,PARENT_BVPS_ADJUST,BASIC_EPS_ADJUST,DILUTED_EPS_ADJUST,PER_NETCASHOPERATE_ADJUST,ROE_WEIGHT_FN,REPORT_TYPE",
        sortColumns: "REPORT_DATE",
        sortTypes: -1,
        pageSize: 4,
        filter: "(SECURITY_CODE=\"" + info.SECURITY_CODE + "\")(REPORT_TYPE=\"\u5E74\u5EA6\u62A5\u544A\")(REPORT_DATE<='" + fieldtools_1["default"].dateformat(info.UPDATE_DATE) + "')"
    }).then(function (json) {
        if (json && json.result && json.result.data && json.result.data.length > 0) {
            for (var i = 0; i < 4; i++) {
                if (json.result.data[i])
                    loadcell(i + 1, json.result.data[i]);
                else
                    delcell(i + 1);
            }
        }
    });
    var zygd_url = "RPT_HOLDERSDECLARE";
    var zygd_filter = "(ORG_CODE=\"" + (info === null || info === void 0 ? void 0 : info.ORG_CODE) + "\")";
    if ((info === null || info === void 0 ? void 0 : info.PREDICT_LISTING_MARKET) == '北交所') {
        zygd_url = 'RPT_HOLDERSDECLARE_BJ';
        zygd_filter = "(SECURITY_CODE=\"" + (info === null || info === void 0 ? void 0 : info.SECURITY_CODE) + "\")";
    }
    //主要股东
    getdata({
        reportName: zygd_url,
        columns: "HOLD_NUM,HOLD_RATIO,HOLDER_NAME,NUM_SUM,RATIO_SUM,RN,END_DATE",
        sortColumns: "RN",
        sortTypes: -1,
        filter: zygd_filter
    }).then(function (json) {
        if (json && json.result && json.result.data && json.result.data.length > 0) {
            var list = json.result.data;
            var count = list.length;
            for (var i = 0; i < count; i++) {
                var item = list[i];
                var tds = $("tr", table_zygd).eq(item.RN);
                $("td", tds).eq(0).html(item.RN);
                $("td", tds).eq(1).html('<div class="ellipsis" style="width: 550px;">' + item.HOLDER_NAME + '</div>').attr("title", item.HOLDER_NAME);
                $("td", tds).eq(2).html(item.HOLD_NUM);
                $("td", tds).eq(3).html(item.HOLD_RATIO);
            }
            $("td", $("tr", table_zygd).eq(11)).eq(1).html(list[0].NUM_SUM);
            $("td", $("tr", table_zygd).eq(11)).eq(2).html(list[0].RATIO_SUM);
            for (var i_1 = count; i_1 < 10; i_1++) {
                $("tr", table_zygd).eq(count + 1).remove();
            }
            $("#date_zygd").html("截止日期:" + fieldtools_1["default"].dateformat(list[0].END_DATE, 'YYYY-MM-DD 周W'));
        }
    });
    //最新公告
    $("#dataview_zxgg").emdataview({
        columns: {
            title: {
                formatter: function (value, item, i, field) {
                    return "<a class=\"ellipsis\" style=\"width:600px;\" href=\"//pdf.dfcfw.com/pdf/H2_" + item.art_code + "_1.pdf\" title=\"" + value + "\">" + value + "</a>";
                }
            },
            column_name: {
                formatter: function (value, item, i, field) {
                    var _a;
                    return ((_a = item.columns[0]) === null || _a === void 0 ? void 0 : _a.column_name) || '-';
                }
            },
            notice_date: emfield.date
        }
    });
}
function getdata(opt) {
    return $.ajax({
        url: web_1["default"].getWebPath('datacenter') + 'api/data/v1/get',
        type: "GET",
        dataType: "jsonp",
        data: $.extend({}, {
            filter: "(ORG_CODE=\"" + info.ORG_CODE + "\")",
            columns: 'ALL',
            source: "WEB",
            client: "WEB"
        }, opt)
    });
}
function loadcell(index, data) {
    $(".REPORT_DATE td", table_cwzb).eq(index + 1).html(fieldtools_1["default"].dateformat(data.REPORT_DATE)); //报表日期	REPORT_DATE
    $(".TOTAL_ASSETS_ADJUST td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.TOTAL_ASSETS_ADJUST, { omit: false, zoom: -8, num: 4 })); //总资产	TOTAL_ASSETS_ADJUST
    $(".TOTAL_EQUITY_ADJUST td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.TOTAL_EQUITY_ADJUST, { omit: false, zoom: -8, num: 4 })); //净资产	TOTAL_EQUITY_ADJUST
    $(".MINORITY_EQUITY_ADJUST td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.MINORITY_EQUITY_ADJUST, { omit: false, zoom: -4, num: 2 })); //少数股东权益	MINORITY_EQUITY_ADJUST
    $(".TOTAL_OPERATE_INCOME td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.TOTAL_OPERATE_INCOME, { omit: false, zoom: -8, num: 4 })); //营业总收入	TOTAL_OPERATE_INCOME
    $(".PARENT_NETPROFIT td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.PARENT_NETPROFIT, { omit: false, zoom: -8, num: 4 })); //净利润	PARENT_NETPROFIT
    $(".CAPITAL_RESERVE_ADJUST td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.CAPITAL_RESERVE_ADJUST, { omit: false, zoom: -4, num: 2 })); //资本公积	CAPITAL_RESERVE_ADJUST
    $(".UNASSIGN_RPOFIT_ADJUST td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.UNASSIGN_RPOFIT_ADJUST, { omit: false, zoom: -8, num: 4 })); //未分配利润	UNASSIGN_RPOFIT_ADJUST
    $(".PARENT_BVPS_ADJUST td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.PARENT_BVPS_ADJUST)); //每股净资产	PARENT_BVPS_ADJUST
    $(".BASIC_EPS_ADJUST td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.BASIC_EPS_ADJUST)); //基本每股收益	BASIC_EPS_ADJUST
    $(".DILUTED_EPS_ADJUST td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.DILUTED_EPS_ADJUST)); //稀释每股收益	DILUTED_EPS_ADJUST
    $(".PER_NETCASHOPERATE_ADJUST td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.PER_NETCASHOPERATE_ADJUST)); //每股现金流	PER_NETCASHOPERATE_ADJUST
    $(".ROE_WEIGHT_FN td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.ROE_WEIGHT_FN)); //净资产收益率	ROE_WEIGHT_FN
}
function delcell(index) {
    $(".REPORT_DATE td", table_cwzb).eq(index + 1).remove();
    $("tr:not(.REPORT_DATE)", table_cwzb).find("td:eq(" + index + ")").remove();
}
